var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _circle, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg_(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 530,
    height: 530,
    viewBox: "0 0 530 530",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 530,
    height: 530,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M408.946 136.045C419.048 135.118 439.35 145.975 436.809 164.936",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M378.616 119.321C385.988 113.217 399.66 106.63 415.292 108.395M415.292 108.395C427.871 109.815 441.721 116.644 454.58 133.483C471.489 155.626 471.531 207.944 413.379 219.318C405.511 220.32 387.551 218.382 378.616 209.447L302.223 285.84L302.223 264.355L268.569 267.997L268.569 238.863L246.86 230.476L323.253 154.084M415.292 108.395C411.65 94.2977 396.212 65.8459 363.595 64.8157C342.375 64.1458 307.717 79.4935 307.373 121.037C307.291 130.988 309.519 145.844 323.253 154.084M323.253 154.084C330.418 158.029 336.763 158.833 342.192 159.881",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M127.095 387.322C116.993 388.249 96.6913 377.392 99.2319 358.431",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M152.065 410.232C144.693 416.336 131.022 422.923 115.389 421.157M115.389 421.157C102.81 419.737 88.9609 412.909 76.1015 396.069C59.1924 373.926 59.1507 321.609 117.302 310.234C125.17 309.233 143.131 311.17 152.065 320.105L212.678 260.707L230.938 266.176L232.152 300.772L268.041 304.413L268.041 316.07L207.429 375.469M115.389 421.157C119.031 435.255 134.469 463.706 167.086 464.736C188.307 465.406 222.965 450.059 223.308 408.515C223.39 398.564 221.162 383.709 207.429 375.469M207.429 375.469C200.263 371.523 193.918 370.719 188.49 369.671",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M179.959 154.758L201.411 183.237",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M242.432 141.679L237.676 175.472",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M149.331 211.811L183.124 216.566",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M367.106 366.828L341.895 341.617",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M307.065 388.485V354.359",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M389.485 306.063H355.358",
    stroke: "#1C1B1F",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M471.593 259.701C474.263 257.249 474.754 252.845 472.689 249.865C470.624 246.885 466.785 246.457 464.115 248.91L456.129 256.246L448.284 249.692C445.51 247.375 441.654 247.966 439.67 251.013C437.687 254.059 438.327 258.407 441.101 260.724L446.417 265.165L441.021 270.122C438.351 272.574 437.861 276.978 439.925 279.958C441.99 282.937 445.829 283.365 448.499 280.913L456.486 273.577L464.33 280.13C467.103 282.447 470.96 281.856 472.944 278.809C474.927 275.763 474.287 271.415 471.513 269.098L466.197 264.657L471.593 259.701Z",
    fill: "#1C1B1F"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.5842 228.811C99.5353 225.313 97.6021 221.326 94.2663 219.906C90.9305 218.486 87.4552 220.171 86.5041 223.669L83.6591 234.134L73.5285 232.773C69.9464 232.292 66.9991 234.848 66.9454 238.483C66.8918 242.118 69.7521 245.455 73.3341 245.936L80.1999 246.858L78.2777 253.928C77.3266 257.427 79.2598 261.414 82.5956 262.834C85.9315 264.253 89.4067 262.568 90.3578 259.07L93.2028 248.605L103.333 249.966C106.915 250.447 109.862 247.891 109.916 244.256C109.969 240.621 107.109 237.285 103.527 236.803L96.6621 235.881L98.5842 228.811Z",
    fill: "#1C1B1F"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 259,
    cy: 101,
    r: 11,
    fill: "#1C1B1F"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 276.5,
    cy: 443.5,
    r: 17.5,
    fill: "#1C1B1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg_);
export default __webpack_public_path__ + "static/media/정형외과_골절.bfc6edc225470e1c9f87d7e79a955733.svg";
export { ForwardRef as ReactComponent };